/* global translations, globals */
import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import MemberStore from '../../stores/MemberStore';
import ImageSvg from '../image/ImageSvg';

const ReactPropTypes = PropTypes;

class MemberName extends React.Component {
  state = {
    member: MemberStore.get(this.props.memberId),
  };

  render() {
    const { member } = this.state;
    if (!member) {
      return (<span />);
    }

    const { status } = member;
    let memberAge = '';
    let name = '';
    let memberAnswerScore = '';

    const {
      truncate,
      hideAge,
      hideAnswerScore,
      memberId,
    } = this.props;
    let { className } = this.props;

    // deleted vai admin
    if (['deleted', 'admin'].indexOf(status) !== -1) {
      switch (status) {
        case 'deleted':
          name = get(translations, 'txt: Dzēsts lietotājs', 'txt: Dzēsts lietotājs');
          break;
        case 'admin':
          name = get(globals, 'currentDomainName', status);
          break;
        default:
          name = get(translations, status, status);
      }
    } else { // active lietotājs
      const { name: memberName } = member;
      name = memberName || '';
      // garos vārdus saīsina
      if (name.length > truncate) {
        name = `${name.substring(0, truncate - 1)}...`;
      }

      // gadi
      if (!hideAge && member.age) {
        memberAge = `(${member.age})`;
      }

      // anketas procenti
      memberAnswerScore = `${get(translations, 'questions.questions_title', '')}${member.answer_score}%`;
    }

    let answerClassName = 'memberAnswerScore g';
    if (['deleted', 'admin'].indexOf(status) !== -1) {
      answerClassName += ' hiddenAnswerScore';
      className += ' hasHiddenAnswerScore';
    }

    return (
      <span key={`name_${memberId}`} className={className}>
        <span className="memberName-name">{name}</span>
        {!hideAge && (
          <span className="memberName-age">{` ${memberAge}`}</span>
        )}
        {!hideAnswerScore && (
          <span className={answerClassName}>
            <span className="btn-static">
              <ImageSvg svg="icon-notes" iconClass="icon--center icon--notes" />
            </span>
            {memberAnswerScore}
          </span>
        )}
      </span>
    );
  }
}

MemberName.propTypes = {
  memberId: ReactPropTypes.string,
  truncate: ReactPropTypes.number,
  className: ReactPropTypes.string,
  hideAnswerScore: ReactPropTypes.bool,
  hideAge: ReactPropTypes.bool,
};

MemberName.defaultProps = {
  memberId: null,
  truncate: 12,
  hideAnswerScore: false,
  className: '',
  hideAge: false,
};

module.exports = MemberName;
